
export const isProd = () => window.location.host.indexOf('ismet.kz') >= 0;
export const isLocalDev = () => window.location.host.indexOf('localhost') >= 0;